import { LoadMoreObserver, Typography, TypographyVariant } from "@onmo/ui";
import { useStyles } from "./ProfileActivity.style";
import map from "lodash-es/map";
import { FC, HTMLAttributes } from "react";
import { User } from "@onmo/graphql/graphql";
import { useTranslation } from "react-i18next";
import { useActivities } from "../../../hooks/useActivities";
import { ActivityCard } from "../ActivityCard/ActivityCard";

interface IProfileActivity extends HTMLAttributes<HTMLDivElement> {
  me: User;
}

const ProfileActivity: FC<IProfileActivity> = ({ me }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { activities, loadMoreActivity } = useActivities();

  return (
    <div className={classes.profileActivity}>
      {!activities?.length ? (
        <Typography variant={TypographyVariant.BodyB5Regular}>
          {t("no_activity_yet")}
        </Typography>
      ) : (
        map(activities, (activity, idx) => {
          return <ActivityCard key={idx} activity={activity} />;
        })
      )}
      {activities?.length && <LoadMoreObserver loadMore={loadMoreActivity} />}
    </div>
  );
};

export default ProfileActivity;
